\
<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="공정 또는 작업장명"
            name="processName"
            v-model="searchParam.processName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="실내외구분"
            name="inOutFlag"
            v-model="searchParam.inOutFlag">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="발생원"
            name="sourceName"
            v-model="searchParam.sourceName">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관련공정 -->
          <c-process
            label="LBL0001705"
            multiple="single"
            :plantCd="searchParam.plantCd"
            name="processCd"
            v-model="searchParam.processCd"
          >
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관리부서 -->
          <c-dept
            type="search"
            label="LBL0001721"
            :plantCd="searchParam.plantCd"
            :isFirstValue="false"
            name="deptCd"
            v-model="searchParam.deptCd"
          >
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <!-- 국소배기장치 목록 -->
        <c-table
          ref="localven"
          title="LBL0010569"
          tableId="localven"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="psiLocalVentilationId"
          :columnSetting="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <c-btn
                v-if="editable"
                label="엑셀업로드"
                icon="upload"
                @btnClicked="excelUploadData"
              />
              <!-- 등록 -->
              <c-btn
                v-if="editable"
                label="LBLREG"
                icon="add"
                @btnClicked="equipmentPopup"
              />
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "local-ven",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            // 사업장
            label: "LBLPLANT",
            align: "center",
            style: "width:100px",
            sortable: true,
            fix: true,
          },
          {
            name: "processName2",
            field: "processName2",
            label: "관련공정",
            align: "center",
            style: "width:80px",
            sortable: true,
            fix: true,
          },
          {
            name: "deptName",
            field: "deptName",
            label: "관리부서",
            align: "center",
            style: "width:80px",
            sortable: true,
            fix: true,
          },
          {
            name: "revisionNum",
            field: "revisionNum",
            label: "Rev.",
            align: "center",
            style: "width:50px",
            sortable: true,
            fix: true,
          },
          {
            name: "processName",
            field: "processName",
            // 공정또는작업장명
            label: "LBL0010609",
            style: "width:150px",
            align: "left",
            type: "link",
            sortable: true,
            fix: true,
          },
          {
            name: "inOutFlag",
            field: "inOutFlag",
            // 실내외구분
            label: "LBL0010570",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "sourceName",
            field: "sourceName",
            // 발생원
            label: "LBL0010571",
            align: "center",
            style: "width:150px",
            sortable: true,
          },
          {
            name: "harmfulTypeCd",
            field: "harmfulTypeCd",
            // 유해물질종류
            label: "LBL0010572",
            style: "width:120px",
            align: "center",
            sortable: true,
          },
          {
            name: "hoodForm",
            field: "hoodForm",
            // 후드형식
            label: "LBL0010573",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "hoodVelocity",
            field: "hoodVelocity",
            // 후드의제어풍속(m/s)
            label: "LBL0010574",
            style: "width:120px",
            align: "center",
            sortable: true,
          },
          {
            name: "reactionVelocity",
            field: "reactionVelocity",
            // 덕트내반응속도(m/s)
            label: "LBL0010575",
            style: "width:120px",
            align: "center",
            sortable: true,
          },
          {
            name: "airVolume",
            field: "airVolume",
            // 배풍량(㎥/min)
            label: "LBL0010576",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "motorVolume",
            field: "motorVolume",
            // 전동기용량(Kw)
            label: "LBL0010577",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "motorExplosionForm",
            field: "motorExplosionForm",
            // 전동기방폭형식
            label: "LBL0010578",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "airCleanType",
            field: "airCleanType",
            // 공기정화장치형식
            label: "LBL0010579",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "airExhaustOrder",
            field: "airExhaustOrder",
            // 배기및처리순서
            label: "LBL0010580",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: "",
        processName: "",
        inOutFlag: "",
        sourceName: "",
        processCd: "",
        deptCd: "",
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.lbe.localven.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () =>
        import(`${"./localExhaustSystemPlanInfoDetail.vue"}`);
      this.popupOptions.title = "LBL0010581"; // 국소배기장치 상세
      this.popupOptions.param = {
        psiLocalVentilationId: result ? result.psiLocalVentilationId : "",
      };
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    excelUploadData() {
      this.popupOptions.title = "국소배기장치 목록 업로드";
      this.popupOptions.target = () =>
        import(`${"./localExhaustSystemPlanInfoExcelUpload.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeExcelUploadPopup;
    },
    closeExcelUploadPopup(_result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (_result && _result.length > 0) {
        let s_data = this.$_.filter(_result, (item) => {
          return !item.error_message;
        });
        this.$_.forEach(s_data, (item) => {
          // item.plantCd = this.searchParam.plantCd;
          item.SysRevision = 1;
          item.regUserId = this.$store.getters.user.userId; // 등록자 ID
          item.chgUserId = this.$store.getters.user.userId; // 수정자 ID
        });

        this.$http.url =
          transactionConfig.psi.lbe.localven.insert.url + "/excel";
        this.$http.type = "POST";
        this.$http.param = s_data;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getList();
        });
      }
    },
  },
};
</script>
